__webpack_require__.p = "/wp-content/plugins/blocks-wrapper-client-stories/build/";